export const Content1DataSource = {
  wrapper: { className: 'home-page-wrapper diag-content1-wrapper' },
  page: { className: 'home-page diag-content1' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.diag.platform'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'REMOTE DIAGNOSIS PLATFORM'
      },
      {
        name: 'content',
        className: 'content',
        children: 'product.diag.introduce'
      }
    ],
  },
};
export const Content2DataSource = {
  wrapper: { className: 'home-page-wrapper diag-content2-wrapper' },
  page: { className: 'home-page diag-content2' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.diag.solution'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'SOLUTION'
      },
    ],
  }
};

export const Content3DataSource = {
  wrapper: { className: 'home-page-wrapper diag-content3-wrapper' },
  page: { className: 'home-page diag-content3' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      { name: 'title', className: 'title-h1', children: 'product.diag.applicationScenario' },
      { name: 'sub-title', className: 'sub-title', children: 'APPLICATION SCENARIO' }
    ],
  },
  childWrapper: {
    className: 'diag-content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'diag-content3-block',
        active: true,
        children: {
          className: 'diag-content3-block-item',
          img: 'diag-02.png',
          title: 'product.diag.carFactory',
          children: [
            {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.carFactoryTitle01',
              children: 'product.diag.carFactoryContent01',
            },
            {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.carFactoryTitle02',
              children: 'product.diag.carFactoryContent02',
            },
            {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.carFactoryTitle03',
              children: 'product.diag.carFactoryContent03',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'diag-content3-block',
        active: true,
        children: {
          className: 'diag-content3-block-item',
          img: 'diag-03.png',
          title: 'product.diag.afterSale',
          children: [
            {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.afterSaleTitle01',
              children: 'product.diag.afterSaleContent01',
            },
            {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.afterSaleTitle02',
              children: 'product.diag.afterSaleContent02',
            },
            {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.afterSaleTitle03',
              children: 'product.diag.afterSaleContent03',
            },
          ],
        },
      }, {
        name: 'block2',
        className: 'diag-content3-block',
        active: true,
        children: {
          className: 'diag-content3-block-item',
          img: 'diag-04.png',
          title: 'product.diag.vehicleOwner',
          children: [
            {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.vehicleOwnerTitle01',
              children: 'product.diag.vehicleOwnerContent01',
            }, {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.vehicleOwnerTitle02',
              children: '',
            }, {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.vehicleOwnerTitle03',
              children: 'product.diag.vehicleOwnerContent03',
            }, {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.vehicleOwnerTitle04',
              children: 'product.diag.vehicleOwnerContent04',
            }, {
              name: 'content',
              className: 'diag-content3-block-content',
              title: 'product.diag.vehicleOwnerTitle05',
              children: 'product.diag.vehicleOwnerContent05',
            },
          ],
        },
      },
    ],
  },
};
